<ng-container
  *appLet="{
    months: months$ | async,
    isOpen: isOpen$ | async,
  } as $comp"
>
<div class="date-range-picker-desktop-modal-wrapper"
  [@openClose]="$comp.isOpen ? 'open' : 'close'"
>
  <div class="date-range-picker-desktop-modal"
    (clickOutside)="onClickOutside()"
    [clickOutsideExclude]="'.date-range-picker-desktop__input'"
  >
    <div
      class="date-range-picker-desktop-modal__button date-range-picker-desktop-modal__button--prev"
      [ngClass]="{
        'date-range-picker-desktop-modal__button--disabled': isDisabledPrevMonth
      }"
      (click)="onPrevMonthClick()"
    >
      <app-svg-icon
        icon="chevron-left"
        [width]="24"
        [height]="24"
        stroke="gray-content-primary"
        [style]="{ opacity: isDisabledPrevMonth ? 0.2 : 1 }"
      ></app-svg-icon>
    </div>
    <div class="date-range-picker-desktop-modal__content">
      <div class="date-range-picker-desktop-modal__options">
        <div class="date-range-picker-desktop-modal__switch">
          <div
            class="date-range-picker-desktop-modal__switch_button date-range-picker-desktop-modal__switch_button--exact"
          >
            {{ noSkipText }}
          </div>
          <div
            class="date-range-picker-desktop-modal__switch_button date-range-picker-desktop-modal__switch_button--flexble"
            (click)="onSkipClick()"
          >
            {{ skipText }}
          </div>
        </div>
      </div>
      <div class="date-range-picker-desktop-modal__content_calendar-area">
        <app-date-range-picker-month
          [month]="firstMonth$ | async"
        ></app-date-range-picker-month>
        <app-date-range-picker-month
          [month]="secondMonth$ | async"
        ></app-date-range-picker-month>
      </div>
    </div>
    <div
      class="date-range-picker-desktop-modal__button date-range-picker-desktop-modal__button--next"
      [ngClass]="{
        'date-range-picker-desktop-modal__button--disabled': isDisabledNextMonth
      }"
      (click)="onNextMonthClick()"
    >
      <app-svg-icon
        icon="chevron-right"
        stroke="gray-content-primary"
        [width]="24"
        [height]="24"
        [style]="{ opacity: isDisabledNextMonth ? 0.2 : 1 }"
      ></app-svg-icon>
    </div>
  </div>
</div>
</ng-container>
